module.exports = JSON.parse(process.env.NEXT_PUBLIC_CLIENT_CREDENTIALS);
